import { render } from "./PermissionComponent.vue?vue&type=template&id=1a4706d0&ts=true"
import script from "./PermissionComponent.vue?vue&type=script&lang=ts"
export * from "./PermissionComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__